<template>
  <form @submit.prevent="submit" class="product-availability-form">
    <div class="uk-modal-body">
      <radio-group-input
        :collection="availableProviders"
        :disabled="!isEditable"
        :errors="fields.errors.provider"
        :inline="false"
        :label="$t('fields.provider')"
        v-if="editableProvider"
        v-model="fields.values.provider"
      />

      <readonly-form-field :label="$t('fields.provider')" v-else>
        <provider-name :name="fields.values.provider" />
      </readonly-form-field>

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.stock"
        :label="$t('fields.stock')"
        :min="0"
        class="uk-width-1-4"
        type="number"
        v-model.number="fields.values.stock"
      />

      <delivery-lead-time-input
        :disabled="!isEditable"
        :errors="fields.errors.deliveryLeadTime"
        :label="$t('fields.deliveryLeadTime')"
        type="text"
        v-model="fields.values.deliveryLeadTime"
      />
    </div>

    <div class="uk-modal-footer uk-text-right">
      <submit-button :disabled="submitDisabled" type="primary" />
      <common-button @click="cancel()">{{$t('actions.cancel')}}</common-button>
    </div>
  </form>
</template>

<script>
import CommonButton from '@/components/CommonButton';
import DeliveryLeadTimeInput from '@/components/DeliveryLeadTimeInput';
import Form from '@/mixins/Form';
import Modal from '@/components/Modal';
import ProviderName from '@/components/ProviderName';
import ReadonlyFormField from '@/components/ReadonlyFormField';
import RadioGroupInput from '@/components/RadioGroupInput';
import SubmitButton from '@/components/SubmitButton';
import TextInput from '@/components/TextInput';

const PROVIDERS = ['BRODOS', 'TELEKOM', 'TVPP'];

export default {
  name: 'product-availability-form',
  mixins: [
    Form({
      provider: { required: true },
      stock: { required: true },
      deliveryLeadTime: { type: Form.Types.NullableObject },
    }),
  ],
  components: {
    CommonButton,
    DeliveryLeadTimeInput,
    Modal,
    ProviderName,
    RadioGroupInput,
    ReadonlyFormField,
    SubmitButton,
    TextInput,
  },
  props: {
    product: Object,
    editableProvider: Boolean,
  },
  computed: {
    providerName() {
      return this.$t(`providers.${this.fields.values.provider}`);
    },
    availableProviders() {
      return PROVIDERS.map((value) => {
        const label = this.$t(`providers.${value}`);
        return { label, value };
      });
    },
    submitDisabled() {
      return !this.isSubmittable || this.isLiveProvider;
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductAvailabilityForm.vue?6595f3c8